import bootstrapSelect from 'bootstrap-select/js/bootstrap-select';

export { bootstrapSelect };
